import React from 'react';
import prices from '../../content/prices.json';
import Markdown from '../../content/Markdown';

const Prices = () => {
  return (
    <section id="prices" name="prices" className="scroll-to block spacer p-top-xl">
      <div className="wrapper">
        <div className="row gutter-width-sm">
          <div className="col-xl-8 col-lg-8 col-md-12 col-sm-12">
            <div className="title">
              <h2>{prices.title}</h2>
            </div>
          </div>
        </div>

        <div className="row gutter-width-sm justify-content-start">
          <div className="col-xl-6 col-lg-6 col-md-9 col-sm-12">
            <Markdown className="description">{prices.intro}</Markdown>
          </div>
        </div>

        <div className="row gutter-width-sm justify-content-start">
          <div className="col-xl-6 col-lg-6 col-md-9 col-sm-12">
            <div className="prices">
              {prices.groups.map((group, g) => (
                <React.Fragment key={g}>
                  <h4>{group.title}</h4>
                  {(group.items || []).map((item, i) => (
                    <React.Fragment key={i}>
                      <div className="price">
                        <span className="item">{item.name}</span>
                        <span className="amount">{item.price}</span>
                      </div>
                      {item.note && <p className="price-annotation">{item.note}</p>}
                    </React.Fragment>
                  ))}
                  {group.text && <Markdown className="description">{group.text}</Markdown>}
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Prices;
